$(function() {
    const $modal = $('#teamModal');
    const $modalBody = $('#modalBody');
    const $modalImage = $('#modalImage');
    const $modalTitle = $('#modalTitle');
    const $modalPos = $('#modalPosition');
    const $modalLink = $('#modalLinkedin');

    // Open Modal
    $('.team-card, .team-card__trigger').on('click', function(e) {
        if ($(e.target).closest('a').length) return;
        
        e.preventDefault();
        
        // Get the card element
        const $card = $(this).closest('.team-card');
        const postId = $card.data('id');

        // Show Modal
        $modal.addClass('is-open');
        $('body').css('overflow', 'hidden'); // Prevent background scrolling

        // Reset Content
        $modalBody.html('<div class="team-modal__loader">Loading...</div>');
        $modalImage.attr('src', '');
        
        // Fetch Data
        $.ajax({
            url: theme_ajax.ajax_url,
            type: 'POST',
            data: {
                action: 'load_team_member_details',
                post_id: postId
            },
            success: function(response) {
                if(response.success) {
                    const data = response.data;
                    
                    // Populate fields
                    $modalTitle.text(data.title);
                    $modalPos.text(data.position);
                    $modalImage.attr('src', data.image_url);
                    $modalBody.html(data.content);
                    
                    if(data.linkedin) {
                        $modalLink.attr('href', data.linkedin).show();
                    } else {
                        $modalLink.hide();
                    }
                }
            },
            error: function() {
                $modalBody.html('<p>Error loading content.</p>');
            }
        });
    });

    // Close Modal Function
    function closeModal() {
        $modal.removeClass('is-open');
        $('body').css('overflow', '');
    }

    // Close triggers
    $('.team-modal__close, .team-modal__overlay').on('click', closeModal);

    // Close on Escape key
    $(document).on('keydown', function(e) {
        if (e.key === "Escape" && $modal.hasClass('is-open')) {
            closeModal();
        }
    });
});